const menus = [
  {
    icon: 'home',
    title: '首页',
    path: '/'
  },
  {
    icon: 'team',
    title: '用户管理',
    children: [{
      title: '用户列表',
      path: '/model/user'
    }, {
      title: '账号申请',
      path: '/model/applicationRecord'
    }, {
      title: '账号变更',
      path: '/model/changeAccountRecord'
    }]
  },
  {
    icon: 'copyright',
    title: '商品管理',
    children: [{
      title: '商品一级分类',
      path: '/model/oneIfication'
    }, {
      title: '商品二级分类',
      path: '/model/classIfication'
    }, {
      title: '商品列表',
      path: '/model/commodityList'
    }]
  },
  {
    icon: 'shopping-cart',
    title: '订单管理',
    children: [{
      title: '订单列表',
      path: '/model/order'
    }, {
      title: '订单评价',
      path: '/model/orderEvaluation'
    }, {
      title: '退换货申请',
      path: '/model/returnExchangeRecords'
    }]
  },
  {
    icon: 'pay-circle',
    title: '优惠券管理',
    children: [{
      title: '优惠券发放',
      path: '/model/couponIssues'
    }, {
      title: '优惠券列表',
      path: '/model/coupons'
    }, {
      title: '运费券列表',
      path: '/model/freightVouchers'
    }]
  },
  {
    icon: 'bank',
    title: '社区管理',
    children: [{
      title: '帖子类别',
      path: '/model/postType'
    }, {
      title: '授权账号',
      path: '/model/authorizeAccount'
    }, {
      title: '帖子列表',
      path: '/model/InformationPosts'
    }]
  },
  {
    icon: 'filter',
    title: '奖品管理',
    children: [{
      title: '大转盘设置',
      path: '/model/turntableSettings'
    }, {
      title: '抽奖记录',
      path: '/model/drawRecords'
    }, {
      title: '幸运星记录',
      path: '/model/luckyStarRecords'
    }, {
      title: '欢乐豆记录',
      path: '/model/happyBeanRecords'
    }]
  },
  {
    icon: 'read',
    title: '文章推荐',
    children: [{
      title: '购买推荐',
      path: '/model/buyRecommendation'
    }, {
      title: '经营案例',
      path: '/model/excellentCases'
    }, {
      title: '产业资讯',
      path: '/model/news'
    }]
  },
  {
    icon: 'notification',
    title: '通知管理',
    children: [{
      title: '消息通知',
      path: '/model/messageNotification'
    }, {
      title: '重要通知',
      path: '/model/importantNotice'
    }]
  },
  {
    icon: 'download',
    title: '下载中心',
    children: [{
      title: '图片上传',
      path: '/model/downloadImage'
    }, {
      title: '视频上传',
      path: '/model/downloadVideo'
    }, {
      title: '音频上传',
      path: '/model/downloadAudio'
    }, {
      title: '文件上传',
      path: '/model/downloadFile'
    }]
  },
  {
    icon: 'form',
    title: '意见管理',
    children: [
      {
        title: '意见反馈',
        path: '/model/feedBack'
      }
    ]
  },
  {
    icon: 'setting',
    title: '基础设置',
    children: [{
      title: '热门搜索',
      path: '/model/popularSearch'
    }, {
      title: '功能类',
      path: '/model/kingKongDistrict'
    }, {
      title: 'banner图',
      path: '/model/bannerImage'
    }, {
      title: '主题背景',
      path: '/model/themeBackground'
    }, {
      title: '品牌专场',
      path: '/model/brandSpecial'
    }, {
      title: '常见问题',
      path: '/model/commonProblem'
    }, {
      title: 'App配置',
      path: '/setting'
    }]
  }
]
export default menus
